const productOptions_Root = document.querySelector('.product-options--root');
const hideTheButton = document.querySelector(".product-buy-buttons--root .product-buy-buttons--primary");
const label_option = document.querySelectorAll(".product-options--container .radios--value-button");

let size_value_input = null;

function productOptions_RootFn(selectedSizeRadio, newItem) {
    if (productOptions_Root) {
        // Get the subscription container and radio buttons
        const subscriptionContainer = productOptions_Root.querySelector('[data-index="1"]');
        const subscriptionRadios = productOptions_Root.querySelectorAll('input[data-option-name="subscription"]');
        const subscriptionLabels = document.querySelectorAll('label[data-option-name="subscription"]');

        const get_collection__handle = productOptions_Root.getAttribute("data-collection-handles").includes("apparel");

        if (!get_collection__handle) {
            hideTheButton.setAttribute("disabled", true);
            if(label_option.length > 0){
                label_option.forEach((label) => {
                    label.style.pointerEvents = 'none';
                })
            }
        }

        const productOptions_Root_dataset = productOptions_Root.dataset;
        const { collectionHandles, productId, productHandle } = productOptions_Root_dataset;

        if (collectionHandles.includes('drinks') || collectionHandles.includes('shots')) {

            // Function to disable/enable subscription options
            function toggleSubscriptionOptions(disable, select_value) {
                subscriptionRadios.forEach((radio, index) => {
                    const label = subscriptionLabels[index];

                    if (select_value === 'Single') {
                        radio.disabled = disable;
                        size_value_input = select_value;    
                        if (radio.value !== 'One-Time Purchase') {

                            // Add visual styling for disabled state
                            if (disable) {
                                label.classList.add("label-disabled");
                                radio.checked = false;
                            }
                        }else{
                            radio.checked = true;
                        }
                    } else {
                        label.style.opacity = '1';
                        label.style.pointerEvents = 'auto';
                        label.style.cursor = 'pointer';
                    }
                });

                // Add/remove disabled class to subscription container
                if (disable) {
                    subscriptionContainer.classList.add('subscription-disabled');
                } else {
                    subscriptionContainer.classList.remove('subscription-disabled');
                }
            }

            function firstHandleSizeChange() {
                const selectedSize = document.querySelector('input[data-option-name="size"]:checked');
                if (selectedSize.value === 'Single') {
                    toggleSubscriptionOptions(true, 'Single');
                } else {
                    toggleSubscriptionOptions(false, 'other');
                } 
            }

            firstHandleSizeChange();
        }

        return subscriptionVariationButton();
        
    }
}

// Initialize the function only if the DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        productOptions_RootFn();
    });
} else {
    productOptions_RootFn();
}

function handleSizeClick(radio) {
    const selectedSizeRadio = radio.value;
    const sizeLabelRadios = productOptions_Root.querySelectorAll('.radios--value-button[data-option-name="size"]');

    // Get the subscription container and radio buttons
    const subscriptionContainer = productOptions_Root.querySelector('[data-index="1"]');
    const subscriptionRadios = productOptions_Root.querySelectorAll('input[data-option-name="subscription"]');
    const subscriptionLabels = document.querySelectorAll('label[data-option-name="subscription"]');

    setTimeout(() => {
        if (selectedSizeRadio === 'Single') {
            
            const radioOneTime = document.querySelector(".radios--value-One-Time input");   
            const subscriptionHiddenInput = document.querySelector("input[name='selling_plan']");
            const slsSelectOption = document.querySelectorAll(".sls-select-container .seal-tight option");
            subscriptionHiddenInput.value = "";  
            if (radioOneTime) {
                radioOneTime.checked = true;
                radioOneTime.dispatchEvent(new Event('change', { bubbles: true }));
            }
        } 
    }, 200); 

    setTimeout(() => {
        if (selectedSizeRadio === 'Single') {
            size_value_input = selectedSizeRadio;
            document.querySelectorAll(".radios--value-Every").forEach((label, i) => {
                label.classList.add("label-disabled");
                label.querySelector('input').removeAttribute("checked");
                label.querySelector('input').disabled = true;
            })
        } else {
            // Re-enable subscription options
            document.querySelectorAll(".radios--value-Every").forEach(label => {
                const input = label.querySelector('input');
                label.classList.remove("label-disabled");
                input.disabled = false;
            });
        }
    }, 500);
}

function handleSubscriptionClick(radio) {

    const sizeLabelRadios = productOptions_Root.querySelectorAll('.radios--value-button[data-option-name="size"]');
    const variant_error_message = document.getElementById('variants_error--message--wrapper');
    // Extract the data-text values into an array
    
    const dataTextValues = Array.from(sizeLabelRadios).map(label => label.getAttribute('data-text'));

    // Try to parse them as numbers if possible
    const numericValues = dataTextValues.map(text => {
    const num = parseInt(text);
        return isNaN(num) ? Infinity : num;
    });

    // Find the minimum value
    const minIndex = numericValues.indexOf(Math.min(...numericValues));
    const minDataText = dataTextValues[minIndex];
    
    setTimeout(() => {
        if(size_value_input != null){
            if (size_value_input === 'Single') {
                variant_error_message.classList.add('show-error--message');
                variant_error_message.querySelector('.variants_error--message').innerText = `Oops! Subscriptions are only available for ${minDataText.toLowerCase()} or more. Try selecting a pack to enjoy our subscription benefits!`
                size_value_input = null;
            }else{
                if (variant_error_message) {
                    variant_error_message.classList.remove('show-error--message');
                }
            }
        }
        return createSubscriptionVariation(radio);
    }, 100);
}

function subscriptionVariationButton(){
    
    // product page
    document.addEventListener('DOMContentLoaded', () => {
        const sizeLabelRadios = productOptions_Root.querySelectorAll('.radios--value-button[data-option-name="size"]');
        const subscriptionRadio = productOptions_Root.querySelectorAll('input[data-option-name="subscription"]');
        productSubscriptionMethods(subscriptionRadio);
        //allVariantRadioButtons(sizeLabelRadios, subscriptionRadio);
    });

    function productSubscriptionMethods(subscriptionRadio){
        const selectors = {
            relatedProducts: '.sealsubs-target-element',
        };

        const observer = new MutationObserver((mutationsList, observer) => {
            mutationsList.some(mutation => {
                // Look only at added nodes
                return [...mutation.addedNodes].some(node => {
                    if (node.nodeType === 1 && node.matches(selectors.relatedProducts)) {
                        node.style.display = 'none';
                        trackSealSubcription(node, subscriptionRadio);
                        observer.disconnect(); // stop if only once
                        return true; // break out
                    }
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };

    function trackSealSubcription(node, subscriptionRadio){
        node.querySelectorAll('.sealsubs-container').forEach((element, i) => {
            const subscriptionWrapper = element.querySelector(".sls-purchase-options-container");
            if(subscriptionWrapper){
                const subscriptionHiddenInput = subscriptionWrapper.querySelector('[name="selling_plan"]');
                const subscriptionsBox = subscriptionWrapper.querySelectorAll(".sls-option-container");
                const slsSelectContainer = subscriptionWrapper.querySelectorAll(".sls-select-container .seal-tight option");
                if(subscriptionsBox.length > 0){
                    subscriptionsBox.forEach((el, i) => {
                        el.classList.remove("sls-active");
                        const radioWrapper = el.querySelector('[role="radio"]');
                        if (radioWrapper) radioWrapper.setAttribute("aria-checked", "false");
                        const input = el.querySelector("input[type=radio]");
                        if (input) input.checked = false; 
                    })
                    // target "One-time purchase" radio parent
                    const oneTimeParent = document.querySelector('[data-one-time-option-radio]')?.closest(".sls-option-container");
                    if (oneTimeParent) {
                        oneTimeParent.classList.add("sls-active");

                        const radioWrapper = oneTimeParent.querySelector('[role="radio"]');
                        if (radioWrapper) radioWrapper.setAttribute("aria-checked", "true");

                        const input = oneTimeParent.querySelector("input[type=radio]");
                        if (input) input.checked = true;
                    }
                    if(hideTheButton){
                        hideTheButton.removeAttribute("disabled");
                    }
                    if(label_option.length > 0){
                        label_option.forEach((label) => {
                            label.style.pointerEvents = 'visible';
                        })
                    }
                    setTimeout(() => {
                        
                        //const subscriptionHiddenInput = subscriptionWrapper.querySelector("input[name='selling_plan']");
                        if (subscriptionHiddenInput) {
                            subscriptionHiddenInput.value = "";
                        }

                        if(subscriptionRadio.length > 0){
                            subscriptionRadio.forEach((subscribeBtn, i) => {
                                if(i > 0){
                                   subscribeBtn.setAttribute("data-option", slsSelectContainer[i - 1].getAttribute('value'));
                                }else{
                                    subscribeBtn.setAttribute("data-option", null);
                                }
                            })    
                        }
                        getSubscriptionOnRefresh();
                    }, 300);

                }
                
            }
        });
    }
}

function createSubscriptionVariation(radio){
    let trackRadio = radio.querySelector('input').value;
    const subscriptionHiddenInput = document.querySelector("input[name='selling_plan']");
    const slsSelectOption = document.querySelectorAll(".sls-select-container .seal-tight option");
    if(trackRadio.includes('Week')){
        subscriptionHiddenInput.value = slsSelectOption[0].value;
    }else if(trackRadio.includes('Month')){
        subscriptionHiddenInput.value = slsSelectOption[1].value;
    }
}

function handleOneTimeClick(radio){
    let trackRadio = radio.querySelector('input').value;
    const subscriptionHiddenInput = document.querySelector("input[name='selling_plan']");
    const slsSelectOption = document.querySelectorAll(".sls-select-container .seal-tight option");
    if(trackRadio.includes('Purchase')){
        subscriptionHiddenInput.value = "";
    }
}

function getSubscriptionOnRefresh() {
    
  let currentVariant = null;

  function applySubscription() {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get("variant");

    if (!variantId) return;

    const select = document.querySelector(".product-buy-buttons--select");
    if (!select) return;

    const selectedOption = [...select.options].find(
      option => option.value === variantId
    );

    if (!selectedOption) return;

    const sellingPlanInput = document.querySelector(
      'input[name="selling_plan"]'
    );
    const sellingPlanOptions = document.querySelectorAll(
      ".sls-select-container .seal-tight option"
    );

    if (!sellingPlanInput || sellingPlanOptions.length === 0) return;

    const label = selectedOption.text;

    // One-Time Purchase
    if (label.includes("One-Time")) {  
      sellingPlanInput.value = "";
    }

    // // Weekly Subscription
    else if (label.includes("Week")) {
      sellingPlanInput.value = sellingPlanOptions[0]?.value || "";
    }

    // // Monthly Subscription
    else if (label.includes("Month")) {
      sellingPlanInput.value = sellingPlanOptions[1]?.value || "";
    }

  }

  applySubscription();
}



// const interval_Id = setInterval(() => {
//     const collection_grid = document.querySelectorAll('.spf-product-card__inner');
      
//     if (collection_grid.length > 0) {
      
//         collection_grid.forEach((list, i) => {
//             const item_list = list.querySelector('.spf-product-card__image-wrapper');

//             if (item_list) {
              
//                 const list_title = item_list.getAttribute('href');
// console.log('Matching product found:', list_title );
//                 if (list_title && list_title.includes('blood-orange-vanilla-delta-9-craft-soda-hectare-s-5mg-copy')) {
//                     console.log('Matching product found:', collection_grid[i]);
//                     collection_grid[i].style.display = 'none';

//                     // Wait 3 seconds, then stop the interval
//                     setTimeout(() => {
//                         clearInterval(interval_Id);
//                         console.log('Interval cleared after finding the product.');
//                     }, 10000); // 3000ms = 3 seconds
//                 }
//             }
//         });
//     }
// }, 1000); // Check every 1 second